import { Alert, AlertDescription, AlertTitle } from '@nesso/ui/primitives/alert';

export function FirstDictationBanner() {
    return (
        <Alert variant="secondary">
            <AlertTitle>Try it out for yourself!</AlertTitle>
            <AlertDescription>
                Practice with our test client to see how quickly natural language turns into a
                clinical note.
            </AlertDescription>
        </Alert>
    );
}
